import { createFileRoute } from '@tanstack/react-router'
import { PlansPage } from '../../../../features/commissions/plans-page'

export const Route = createFileRoute('/_app/commissions/plans/')({
  component: PlansPage,
})
